import dayjs from "dayjs";
import * as Yup from "yup";

export const initialValues = {
  shiftId: null,
  startDate: dayjs(),
};

const employeeEmploymentShift = Yup.object().shape({
  shiftId: Yup.string().required("Please enter."),
  startDate: Yup.string().required("Please select start date."),
});

export default employeeEmploymentShift;
